export default [
    {
        path: '/signatures/user-subscribers',
        name: 'signatures-user-subscribers',
        component: () => import ('./views/UserSubscriberIndex'),
        meta: {
            title: 'Usuários assinantes',
            icon: 'mdi-account',
            breadcrumbs: [
                { text: 'Lista de usuários assinantes', disabled: true }
            ]
        }
    },
]
